import {parseToken} from "./UtilityService";

const toStandardBase64 = (token) => token.replace(/-/g, '+').replace(/_/g, '/');

export const getArticleData = (params) => {
    const {token = ''} = params;

    return parseToken(toStandardBase64(token));
};

export default {
    getArticleData
};
